import { useSession } from './useSession';
import { Status } from './types';
export var useToken = function () {
    var _a = useSession(), status = _a.status, token = _a.token;
    return status === Status.Authenticated ? token : undefined;
};
//# sourceMappingURL=useToken.js.map